module.exports = __webpack_public_path__ + "static/img/news23-cover.6ba20a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news23-cover.jpg
// module id = 8aQs
// module chunks = 0